import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Layout from 'components/Layout';
import { NavCenterContainer, NavCenterItem } from 'components/Navigation';
import LoadingPage from 'components/LoadingPage';
import ErrorPage from 'components/ErrorPage';
import SearchButton from 'components/SearchButton';
import { navigateOut } from 'utils';

const GalleryContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  text-align: left;
`;

const Container = ({
  scrollKey,
  backText = '',
  backNavigate = navigateOut,
  center,
  right,
  tabs,
  body
}) => {
  const innerBody = (
    <GalleryContainer className="gallery-container">{body}</GalleryContainer>
  );
  return (
    <Layout
      backText={backText}
      backNavigate={backNavigate}
      center={center}
      right={right}
      name="Gallery"
      scrollKey={scrollKey}
      tabs={tabs}
      pageElement={innerBody}
    />
  );
};

export default connect(({ registry: { currentUser } }) => ({
  currentUser
}))(
  class Gallery extends PureComponent {
    static propTypes = {
      apps: PropTypes.arrayOf(PropTypes.shape()),
      banners: PropTypes.arrayOf(PropTypes.shape()),
      collections: PropTypes.arrayOf(PropTypes.shape()),
      direction: PropTypes.string,
      error: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
      installedApps: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.shape()),
        PropTypes.shape()
      ]),
      InstalledPage: PropTypes.elementType,
      installedPageName: PropTypes.string,
      listPageName: PropTypes.string,
      loading: PropTypes.bool,
      pageName: PropTypes.string,
      rootUrl: PropTypes.string,
      showAll: PropTypes.bool,
      currentUser: PropTypes.shape(),
      selectedApp: PropTypes.string
    };

    get scrollKey() {
      return this.props.showAll ? 'discovery' : 'installed';
    }

    renderTabs() {
      const { rootUrl, showAll, installedPageName, listPageName } = this.props;
      return (
        <NavCenterContainer centerPriority>
          <NavCenterItem
            active={!showAll}
            to={rootUrl}
            redirect={true}
            pageDirection="slide-right"
            data-test-type="installed-apps-link"
          >
            {installedPageName}
          </NavCenterItem>
          <NavCenterItem
            active={showAll}
            to={`${rootUrl}/gallery`}
            redirect={true}
            pageDirection="slide-left"
            data-test-type="all-apps-link"
          >
            {listPageName}
          </NavCenterItem>
        </NavCenterContainer>
      );
    }

    renderSearchButton() {
      const { showAll, showSearch } = this.props;
      if (showAll && showSearch) {
        const hash = window.location.hash.slice(2);
        const type = hash.startsWith('apps') ? 'apps' : 'clocks';
        return <SearchButton type={type} pageType="Discovery" />;
      }
      return null;
    }

    renderBody() {
      const {
        pageLayoutItems,
        installedApps,
        loading,
        showAll,
        DiscoveryPage,
        InstalledPage,
        error,
        currentUser,
        selectedApp,
        favorites
      } = this.props;

      let body;

      if (error) {
        body = <ErrorPage>{error.message}</ErrorPage>;
      } else if (loading) {
        body = <LoadingPage headerHeight={105} />;
      } else if (showAll) {
        body = <DiscoveryPage pageLayoutItems={pageLayoutItems} />;
      } else {
        body = (
          <InstalledPage
            apps={installedApps}
            currentUser={currentUser}
            selectedApp={selectedApp}
            favorites={favorites}
          />
        );
      }

      return body;
    }

    render() {
      const { direction, pageName, backText } = this.props;

      return (
        <Container
          backText={backText}
          center={pageName}
          right={this.renderSearchButton()}
          direction={direction}
          scrollKey={this.scrollKey}
          tabs={this.renderTabs()}
          body={this.renderBody()}
        />
      );
    }
  }
);
